<template>
  <div class="header-logo">
    <router-link 
      to="/">
      <img src="@/assets/fes-logo.svg" class="logo" style="margin: 0 auto; display: block;"/>
    </router-link>
  </div>
</template>

<script>
export default {
  name: "AppLayoutHeader",
  data() {
    return {
    }
  },
}
</script>

<style lang="scss" scoped>
div.header-logo {
  padding: 16px 0;
  position: absolute;
  width: 100vw;
  top: 0;
  z-index: 1;

  .logo {
    height: 60px;
    @media #{map-get($display-breakpoints, 'sm-and-down')} {
      height: 48px;
    } 
  }       

  &.header-logo--fix {
    background: rgba(250, 250, 250, 0.72);
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
  }

  &.header-logo--static {
    position: absolute;
  }
}
</style>
